var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2503 16.7474C25.4712 16.7475 25.6834 16.8353 25.8395 16.9915L27.5054 18.6582L27.5623 18.7217C27.8292 19.049 27.8103 19.5315 27.5054 19.8366C27.2001 20.1417 26.7169 20.1608 26.3896 19.8936L26.327 19.8366L26.1634 19.673C25.3878 23.4722 22.0277 26.3307 17.9993 26.3307C13.397 26.3307 9.66602 22.5998 9.66602 17.9974C9.66602 13.395 13.397 9.66406 17.9993 9.66406C21.0577 9.66406 23.73 11.3124 25.1787 13.7648C25.4127 14.1611 25.2811 14.6717 24.8849 14.9058C24.4887 15.1396 23.978 15.0082 23.744 14.612C22.5827 12.6462 20.4441 11.3307 17.9993 11.3307C14.3175 11.3307 11.3327 14.3155 11.3327 17.9974C11.3327 21.6793 14.3175 24.6641 17.9993 24.6641C21.1578 24.6641 23.8011 22.4671 24.4894 19.5184L24.172 19.8366C23.8466 20.1619 23.3191 20.1619 22.9937 19.8366C22.6683 19.5111 22.6682 18.9836 22.9937 18.6582L24.6603 16.9915L24.7222 16.9362C24.8704 16.8148 25.057 16.7474 25.2503 16.7474ZM17.166 13.8307C17.166 13.3705 17.5391 12.9974 17.9993 12.9974C18.4596 12.9974 18.8327 13.3705 18.8327 13.8307V17.5514L20.9616 18.9707L21.0299 19.0212C21.3561 19.2897 21.4321 19.7672 21.1927 20.1263C20.9534 20.4853 20.4836 20.5989 20.1104 20.4014L20.0371 20.3574L17.5371 18.6908C17.3053 18.5362 17.166 18.276 17.166 17.9974V13.8307Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockSvg);
export default __webpack_public_path__ + "static/media/clockSvg.5fc29f0704a257644986d19dc8d591a4.svg";
export { ForwardRef as ReactComponent };